import React from 'react'
import {
  useNavigate
} from "react-router-dom";

export default function Navbar({ pageType }) {
  const [currentUser, setCurrentUser] = React.useState("")
  const [permissions, setPermissions] = React.useState("")
  let navigate = useNavigate();
  const gotoHome = () => {
    navigate('/');
  }

  const gotoLogin = () => {
    navigate('/login');
  }

  const handleLogout = async () => {
    try {
      const response = await fetch('https://ic360portalbackend.azurewebsites.net/api/auth/logout', {
        method: 'POST',
        headers: {
          'Content-type': 'application/JSON',
        },
        credentials: "include",
      })

      const data = await response.json();
    } catch (error) {
      console.error("Error:", error)
    }

    setCurrentUser("")
    setPermissions("")
    sessionStorage.clear();
    sessionStorage.removeItem('currentUser');
    navigate('/')

    window.location.reload();
  }

  const gotoDevRegister = () => {
    navigate('/register');
  }


  React.useEffect(() => {
    const user = sessionStorage.getItem('currentUser');

    if (user !== null) {
      setCurrentUser(user)
    } else {
      setCurrentUser("")
    }

  }, [])

  return (<>
    <div className='navbar-wrapper'>
      <div className="navbar-company-image" onClick={() => { navigate('/') }}></div>

      <div className='navbar'>
        <span className='navbar-item' onClick={gotoHome}>Home</span>

        {currentUser === 'software.dev@ic360.com.au' &&
          <>
            <span className="login-help dev-signup" onClick={gotoDevRegister}>Dev signup</span>
          </>}

        {currentUser !== '' && currentUser !== undefined ?
          <>
            <span className='curr-user-email'>Logged in as <b className='navbar-name-orange'>{currentUser}</b></span>
            <span className='navbar-item' onClick={handleLogout}>Logout</span>
          </>
          :
          <span className='navbar-item' onClick={gotoLogin}>Login</span>
        }
      </div>
    </div>

    {pageType === "Dashboard"
      ? <div className="navbar-line-dashboard"></div>
      : <div className="navbar-line"></div>
    }
  </>

  )
}
